module.exports = __webpack_public_path__ + "img/video-control--prev.2fdf6026.svg";